import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wepac-layout',
  templateUrl: './wepac-layout.component.html'
})
export class WepacLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
